import { iotRequest } from './iot_http';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;
const PATH = '/api/iot/rimappature/chiuse';

// The review queue of the orphaned Assegnazioni (US 33). All three routes
// already exist server-side (`IotRimappatureChiuseController`, BSDEVPLAT-98):
// the panel adds no route of its own.
//
// The parameter is called `businessId`, not `esercizioId` — that is the name the
// route declares, and the name of the column underneath
// (`iot_assegnazione_rimappatura.business_id`). The Assegnazione routes call it
// `esercizioId`: it is the server that is not uniform, and renaming it here
// would mean sending a parameter nobody reads, i.e. reading the queue of every
// esercizio.
//
// The queue's fourth operation — reassigning the probe — is not here: it is a
// `POST /api/iot/assegnazioni` like any other new Assegnazione, and the server
// closes the voce inside the same transaction as the new row
// (`IotAssegnazioneCrudService.crea`). A close-by-reassignment route does not
// exist on purpose.

/**
 * The CHIUSA voci nobody has reviewed yet, for one esercizio. The route does not
 * paginate: they are the open voci of a single esercizio and an operator answers
 * them one at a time.
 */
export const getVociRimappaturaAperte = (esercizioId) =>
  iotRequest(
    `${BASE_URL}${PATH}?businessId=${encodeURIComponent(esercizioId)}`,
    'GET',
  );

/**
 * The count alone, which is a resource of its own: it is needed where the queue
 * is signalled without being shown — the publication screen — and asking for the
 * list to count it would make the rows be paid for by a screen that never shows
 * them.
 */
export const getConteggioVociRimappatura = (esercizioId) =>
  iotRequest(
    `${BASE_URL}${PATH}/conteggio?businessId=${encodeURIComponent(esercizioId)}`,
    'GET',
  );

/**
 * Closes a voce by archiving it. The reason is mandatory server-side
 * (`ArchiviaVoceRimappaturaRequest`): archiving means deciding that a fridge
 * stays knowingly unwatched, and without the written why it would be the silence
 * of US 33 with a placeholder on top.
 */
export const archiviaVoceRimappatura = (id, ragione) =>
  iotRequest(`${BASE_URL}${PATH}/${id}/archiviazione`, 'POST', { ragione });
